import { render, staticRenderFns } from "./FilterButton.vue?vue&type=template&id=331d88a2&scoped=true&"
import script from "./FilterButton.vue?vue&type=script&lang=js&"
export * from "./FilterButton.vue?vue&type=script&lang=js&"
import style0 from "./FilterButton.vue?vue&type=style&index=0&id=331d88a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331d88a2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
